import { BroadCastForm } from 'src/components/model/broadCast/form';

export const BroadCastCreateForm: React.FC = () => {
  return <BroadCastForm />;
};
